module.exports = "https://static.wmbcdn.com/uniweb/images/f9e4b0d31fcedf4bef0fedf94923fa83.svg";